import { render } from "./postReviewModal.vue?vue&type=template&id=4be3fb42&scoped=true"
import script from "./postReviewModal.vue?vue&type=script&lang=js"
export * from "./postReviewModal.vue?vue&type=script&lang=js"

import "./postReviewModal.vue?vue&type=style&index=0&id=4be3fb42&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4be3fb42"

export default script